import { useRef } from 'react';
import PropTypes from 'prop-types';

const FieldSelect = ({ fields, onSelect }) => {
  const selectRef = useRef();
  const onValueSelected = () => {
    if (selectRef.current.value) {
      onSelect(selectRef.current.value);

      // On réinitialise le champ à la valeur par défaut
      selectRef.current.value = '';
    }
  };
  const options = [...fields]
    .sort((firstField, secondField) =>
      firstField.label.localeCompare(secondField.label, 'fr'),
    )
    .map((field) => (
      <option value={field.id} key={field.id}>
        {field.label}
      </option>
    ));
  return (
    <div className="bloc-thematique-field-select-container">
      <select
        className="bloc-thematique-field-select"
        onChange={onValueSelected}
        ref={selectRef}
        defaultValue=""
      >
        <option value="" disabled>
          Ajouter un champ
        </option>
        {options}
      </select>
    </div>
  );
};
FieldSelect.propTypes = {
  fields: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default FieldSelect;
